import { useState, useEffect } from 'react';
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';
import { useNavigate } from 'react-router-dom';

interface Article {
  id: string;
  title: string;
  content: string;
  category: string;
  excerpt: string;
  image_url: string;
  author: string;
  published_at: string;
  tags: string[];
  view_count: number;
}

export default function NewsSection() {
  const navigate = useNavigate();
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/get-articles?limit=6`,
        {
          headers: {
            'Authorization': `Bearer ${import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY}`,
          },
        }
      );
      
      if (response.ok) {
        const data = await response.json();
        console.log('獲取到的文章:', data);
        setArticles(data.articles || []);
      } else {
        console.error('API 回應錯誤:', response.status);
        setArticles(getDefaultArticles());
      }
    } catch (error) {
      console.error('獲取文章失敗:', error);
      setArticles(getDefaultArticles());
    } finally {
      setLoading(false);
    }
  };

  const getDefaultArticles = () => [
    {
      id: '1',
      title: '2025年十二星座年度運勢大解析',
      excerpt: '新的一年即將到來，各個星座在愛情、事業、財運方面將迎來怎樣的變化？讓我們一起來看看...',
      published_at: '2024-01-15',
      category: '星座運勢',
      image_url: 'https://public.readdy.ai/ai/img_res/56f88118bdf762d574f76db4b7d1a0fb.jpg',
      author: '星座專家',
      content: '',
      tags: ['星座', '運勢'],
      view_count: 156
    },
    {
      id: '2',
      title: '2025年塔羅牌愛情運勢完整指南',
      excerpt: '塔羅牌作為一種古老的占卜工具，在2025年將為您的愛情運勢帶來怎樣的指引？探索其神秘面紗...',
      published_at: '2024-01-12',
      category: '塔羅占卜',
      image_url: 'https://readdy.ai/api/search-image?query=Mystical%20tarot%20cards%20spread%20on%20purple%20velvet%20cloth%20with%20golden%20decorations%2C%20soft%20candlelight%20creating%20magical%20atmosphere%2C%20ornate%20card%20designs%20with%20celestial%20symbols%2C%20professional%20fortune%20telling%20setup%2C%20warm%20ambient%20lighting%2C%20high%20quality%20photography&width=800&height=450&seq=tarot2025&orientation=landscape',
      author: '塔羅大師',
      content: '',
      tags: ['塔羅', '愛情'],
      view_count: 234
    },
    {
      id: '3',
      title: '2025年八字命理流年運勢解析',
      excerpt: '五行學說是中華傳統文化的重要組成部分，在2025年的八字命理中將發揮著關鍵作用。了解流年運勢...',
      published_at: '2024-01-10',
      category: '八字算命',
      image_url: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20study%20room%20with%20ancient%20books%20and%20scrolls%2C%20calligraphy%20brushes%20and%20ink%20stone%2C%20red%20and%20gold%20decorations%2C%20wooden%20furniture%20with%20intricate%20carvings%2C%20warm%20lighting%20creating%20scholarly%20atmosphere%2C%20cultural%20heritage%20theme%2C%20professional%20photography&width=800&height=450&seq=bazi2025&orientation=landscape',
      author: '命理大師',
      content: '',
      tags: ['八字', '流年'],
      view_count: 189
    },
    {
      id: '4',
      title: '紫微斗數十二宮位詳細解析',
      excerpt: '紫微斗數作為中國傳統命理學的重要分支，十二宮位的解讀是理解命盤的關鍵...',
      published_at: '2024-01-08',
      category: '紫微斗數',
      image_url: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20star%20chart%20with%20purple%20and%20gold%20celestial%20symbols%2C%20mystical%20cosmic%20diagram%20showing%20palace%20positions%2C%20traditional%20astronomy%20illustration%20with%20constellation%20patterns%2C%20deep%20space%20background%20with%20glowing%20stars%2C%20spiritual%20divination%20theme%2C%20high%20quality%20digital%20art&width=800&height=450&seq=ziwei2025&orientation=landscape',
      author: '紫微大師',
      content: '',
      tags: ['紫微', '宮位'],
      view_count: 167
    },
    {
      id: '5',
      title: '塔羅牌大阿爾克那牌義完整解析',
      excerpt: '大阿爾克那22張牌代表人生的重要課題和靈性成長的旅程，深入了解每張牌的含義...',
      published_at: '2024-01-05',
      category: '塔羅占卜',
      image_url: 'https://readdy.ai/api/search-image?query=Mystical%20tarot%20cards%20spread%20on%20purple%20velvet%20cloth%20with%20golden%20decorations%2C%20soft%20candlelight%20creating%20magical%20atmosphere%2C%20ornate%20card%20designs%20with%20celestial%20symbols%2C%20professional%20fortune%20telling%20setup%2C%20warm%20ambient%20lighting%2C%20high%20quality%20photography&width=800&height=450&seq=tarot2025b&orientation=landscape',
      author: '塔羅大師',
      content: '',
      tags: ['塔羅', '牌義'],
      view_count: 278
    },
    {
      id: '6',
      title: '八字合婚配對完整指南',
      excerpt: '通過八字命理分析兩人的婚姻緣分，了解彼此的性格特質和相處之道，為美滿婚姻打下基礎...',
      published_at: '2024-01-03',
      category: '八字算命',
      image_url: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20study%20room%20with%20ancient%20books%20and%20scrolls%2C%20calligraphy%20brushes%20and%20ink%20stone%2C%20red%20and%20gold%20decorations%2C%20wooden%20furniture%20with%20intricate%20carvings%2C%20warm%20lighting%20creating%20scholarly%20atmosphere%2C%20cultural%20heritage%20theme%2C%20professional%20photography&width=800&height=450&seq=bazi2025b&orientation=landscape',
      author: '命理大師',
      content: '',
      tags: ['八字', '合婚'],
      view_count: 312
    }
  ];

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('zh-TW');
  };

  const getCategoryFallbackImage = (category: string) => {
    const timestamp = Date.now();
    const fallbackImages = {
      '塔羅占卜': `https://readdy.ai/api/search-image?query=Mystical%20tarot%20cards%20spread%20on%20purple%20velvet%20cloth%20with%20golden%20decorations%2C%20soft%20candlelight%20creating%20magical%20atmosphere%2C%20ornate%20card%20designs%20with%20celestial%20symbols%2C%20professional%20fortune%20telling%20setup%2C%20warm%20ambient%20lighting%2C%20high%20quality%20photography&width=800&height=450&seq=tarot${timestamp}&orientation=landscape`,
      '八字算命': `https://readdy.ai/api/search-image?query=Traditional%20Chinese%20study%20room%20with%20ancient%20books%20and%20scrolls%2C%20calligraphy%20brushes%20and%20ink%20stone%2C%20red%20and%20gold%20decorations%2C%20wooden%20furniture%20with%20intricate%20carvings%2C%20warm%20lighting%20creating%20scholarly%20atmosphere%2C%20cultural%20heritage%20theme%2C%20professional%20photography&width=800&height=450&seq=bazi${timestamp}&orientation=landscape`,
      '紫微斗數': `https://readdy.ai/api/search-image?query=Ancient%20Chinese%20star%20chart%20with%20purple%20and%20gold%20celestial%20symbols%2C%20mystical%20cosmic%20diagram%20showing%20palace%20positions%2C%20traditional%20astronomy%20illustration%20with%20constellation%20patterns%2C%20deep%20space%20background%20with%20glowing%20stars%2C%20spiritual%20divination%20theme%2C%20high%20quality%20digital%20art&width=800&height=450&seq=ziwei${timestamp}&orientation=landscape`,
      '星座運勢': `https://readdy.ai/api/search-image?query=Beautiful%20zodiac%20wheel%20with%20twelve%20constellation%20symbols%20glowing%20in%20golden%20light%20against%20deep%20purple%20starry%20night%20sky%2C%20mystical%20cosmic%20background%20with%20nebula%20and%20stars%2C%20professional%20astrology%20theme%2C%20modern%20spiritual%20aesthetic%2C%20high%20quality%20digital%20art&width=800&height=450&seq=zodiac${timestamp}&orientation=landscape`
    };
    
    return fallbackImages[category] || fallbackImages['星座運勢'];
  };

  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>, category: string) => {
    const target = e.target as HTMLImageElement;
    if (!target.dataset.retried) {
      target.dataset.retried = 'true';
      target.src = getCategoryFallbackImage(category);
    }
  };

  if (loading) {
    return (
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto"></div>
            <p className="mt-4 text-gray-600">載入中...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            命理資訊
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            最新的命理知識、運勢分析和傳統文化解讀，助您深入了解命理學的奧秘
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {articles.map((article) => (
            <Card key={article.id} hover className="overflow-hidden">
              <div className="relative">
                <img 
                  src={article.image_url || getCategoryFallbackImage(article.category)} 
                  alt={article.title}
                  className="w-full h-48 object-cover object-top"
                  onError={(e) => handleImageError(e, article.category)}
                  loading="lazy"
                />
                <div className="absolute top-4 left-4 bg-purple-600 text-white px-3 py-1 rounded-full text-sm whitespace-nowrap">
                  {article.category}
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center text-sm text-gray-500 mb-3">
                  <div className="w-4 h-4 flex items-center justify-center mr-2">
                    <i className="ri-calendar-line text-xs"></i>
                  </div>
                  {formatDate(article.published_at)}
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3 line-clamp-2">{article.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-3">{article.excerpt}</p>
                <div className="flex items-center justify-between">
                  <Button 
                    variant="outline" 
                    size="sm"
                    onClick={() => navigate(`/news/${article.id}`)}
                  >
                    閱讀更多
                  </Button>
                  <div className="flex items-center text-xs text-gray-400">
                    <div className="w-3 h-3 flex items-center justify-center mr-1">
                      <i className="ri-eye-line"></i>
                    </div>
                    {article.view_count}
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <Button 
            size="lg"
            onClick={() => navigate('/news')}
          >
            查看更多資訊
          </Button>
        </div>
      </div>
    </section>
  );
}
